import React from "react"
import { StyledButton } from "./style";


interface IProps {
  LeftIcon?: React.ReactNode;
  RightIcon?: React.ReactNode;
  background?: string;
  title: any;
  onClick?: () => void;
  colorfont: string;
  id?: string;
  type?: "button" | "submit" | "reset";
  style?: React.CSSProperties;
  disabled?: boolean;
}

export const Button = ({ LeftIcon, RightIcon, background, title, onClick, colorfont, id, type, style, disabled }: IProps) => {
  return (
    <StyledButton disabled={disabled} id={id} type={type} onClick={onClick} backgroundcolor={background} colorfont={colorfont} style={style}>
      {LeftIcon}
      {title}
      {RightIcon}
    </StyledButton>
  )
}